import { Box, Typography } from '@mui/material';
import SearchIcon from '../CustomSVGIcons/SearchIcon';

import { theme } from '../../constants/theme';
import { useThemeContext } from '../../hook/useThemeManager';
import { FONT_ENUM } from '../../types/global/fonts.types';

import { Spinner } from '@chakra-ui/react';

export const LoadingOverlay = () => {
    const { themeStyle } = useThemeContext();
    return (
        <Box style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
            <Spinner color={theme[themeStyle].tag_white} size="xl" h={20} w={20} />
        </Box>
    );
};

export const NoRowsOverlay = () => {
    const { themeStyle } = useThemeContext();
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100%',
                gap: 3,
            }}>
            <Box>
                <SearchIcon fill={theme[themeStyle].tag_white} />
            </Box>
            <Box>
                <Typography
                    style={{ color: theme[themeStyle].tag_white, fontSize: 18, fontFamily: FONT_ENUM.MAIN_REGULAR }}>
                    No Data Available
                </Typography>
            </Box>
        </Box>
    );
};

export const NoResultsFound = () => {
    const { themeStyle } = useThemeContext();
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100%',
                gap: 3,
            }}>
            <Box>
                <SearchIcon fill={theme[themeStyle].tag_white} />
            </Box>
            <Box>
                <Typography
                    style={{ color: theme[themeStyle].tag_white, fontSize: 18, fontFamily: FONT_ENUM.MAIN_REGULAR }}>
                    No Results found
                </Typography>
            </Box>
        </Box>
    );
};
